export const isCohortPracticeProblemStarred = (cohort, problemId) =>
  cohort &&
  cohort.starredPracticeProblems &&
  cohort.starredPracticeProblems.includes(problemId)
